<template>
  <v-app class="app">
    <v-overlay :value="loadPage.show" class="text-center" :opacity="0.7" z-index="1000">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
      <p>{{loadPage.message}}</p>
    </v-overlay>

    <!-- If isLoggedIn puede ver el menú, sino ve el admin basico -->

    <v-app-bar class="bar" app height="64" color="primary" dark>
      <v-btn v-if="$store.getters.isLoggedIn" icon @click="drawer = !drawer" dark :disabled="($route.name == 'Unauthorized' || $route.name == 'Authenticate')">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <Header :drawer="drawer"></Header>
    </v-app-bar>
    
    <v-navigation-drawer v-model="drawer" v-if="drawer && $store.getters.isLoggedIn" app  class="navigation-custom">
      <NavigationMenu></NavigationMenu>
    </v-navigation-drawer>

    <v-main class="main-custom">
      <v-container fluid class="pa-6">
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar v-model="$store.state.snackbar.show" style="z-index: 1000000 !important;" :color="$store.state.snackbar.color" timeout="3000">
        {{ $store.state.snackbar.message }}
    </v-snackbar>

    <!-- <v-snackbar
      vertical
      v-model="$store.state.quickMessage.snackbar.show"
      :color="$store.state.quickMessage.snackbar.color"
      :timeout="$store.state.quickMessage.snackbar.time"
      top
      elevation="24"
      >
        <div v-if="$store.state.quickMessage.snackbar.isArray">
          <div>
            <strong>{{ $store.state.quickMessage.snackbar.title }}</strong>
          </div><br>
          <div v-for="(item, index) in $store.state.quickMessage.snackbar.message" :key="index">
            - {{ item.text }}
          </div>
        </div>
        <div v-else >{{ $store.state.quickMessage.snackbar.message }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn color="white"
                  text
                  v-if="$store.state.quickMessage.snackbar.buttonClose === true"
                  v-bind="attrs"
                  @click="$store.state.quickMessage.snackbar.show = false">
                        Cerrar
            </v-btn>
        </template>
    </v-snackbar> -->
    <v-footer app>
      <!-- -->
    </v-footer>
  </v-app>
</template>

<script>

import Header from "./views/app/Header.vue";
import NavigationMenu from "./views/app/NavigationMenu.vue";
// import eventBus from "./event-bus.js"
export default {
  name: 'App',

  components: {
    Header,
    NavigationMenu,
  },
  data: () => ({
    drawer: true,
    loadPage : { show: false, message: 'Cargando...' }
  }),
  created(){
    // const data = {
    //                 show: false,
    //                 message:"",
    //                 color: "",
    //             }

    // this.$store.dispatch("quickMessage/activeMessage", data);
  },
  mounted(){
    // let vm = this;
    // eventBus.$on("loadPage", function (data) {
    //   vm.loadPage = data;
    // });
  },
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    currentRouteName() {
      return this.$route.name;
    },
  },
  watch:{
    '$route.name'(val){
      if(val == 'Unauthorized' || val == 'Authenticate') this.drawer = false
      else this.drawer = true
    }
  }
};
</script>

<style>
  .bar {
    box-shadow: 0px 6px 32px #7052FB33;
    opacity: 1;
  }

  .navigation-custom {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
  }

  .main-custom {
    background: #F5F7FF 0% 0% no-repeat padding-box;
    opacity: 1;
  }


  /* width */
  ::-webkit-scrollbar {
    width: .9rem !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f2f3f8 !important;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #B2B2B2 !important;
    border-radius: 10px !important;
  }
</style>
